import { BffCrmPersonChatRetrieveResponse } from '@fireflyhealth/api'

export const getPubnubChannelForThread = (thread: string) => `thread.${thread}`

type ChatCommunication = Extract<
  BffCrmPersonChatRetrieveResponse['communications']['results'][number]['content_object'],
  { kind: 'chat' }
>

export const isUrgent = (message: Pick<ChatCommunication, 'is_urgent_message'>) => {
  return !!message.is_urgent_message
}
